import { Directive, ElementRef, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserService } from '@app/core/services/user.service';
import { UserType } from '@app/core/utils';
import { isNotEmpty } from '@app/util';
import * as R from 'ramda';

/**
 * This directive should be used in case when you need to perform check for type of the logged in user.
 * Type of the users that should be checked should be provided in the input.
 * Example: *pcsShowIfUser="['applicant', 'im']" or *pcsShowIfUser="['coss']"
 */
@Directive({
  selector: '[pcsShowIfUser]'
})
export class ShowIfUserDirective {

  constructor(private element: ElementRef,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private userService: UserService) {
  }

  @Input()
  set pcsShowIfUser(values) {
    this.viewContainer.clear();
    if (this.isUserOfType(values)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

  isUserOfType(userTypes) {
    return isNotEmpty(userTypes) && R.any((userType: any) => R.cond([
      [R.equals(UserType.APPLICANT), R.always(this.userService.isApplicantUser())],
      [R.equals(UserType.IM), R.always(this.userService.isImUser())],
      [R.equals(UserType.COSS), R.always(this.userService.isCossUser())],
      [R.equals(UserType.ADMIN), R.always(this.userService.isAdmin())],
      [R.equals(UserType.RNEJO), R.always(this.userService.isRneJo())],
      [R.equals(UserType.RU), R.always(this.userService.isRu())],
    ])(R.toLower(userType) as UserType), userTypes);
  }
}
